module.exports = __webpack_public_path__ + "img/popularity-checked-zh.b01fdbbe.png";